import fetchClient from './fetchClient';

import { errorHandler } from "./utils";


const config = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};

export const markTaskAsDone = async (id: string) => {
    const res = await fetchClient
        .put(`/tasks/${id}/done`, {}, config())
        .catch(errorHandler);
    return res.data;
};

export const getMyTasks = async () => {
    const res: any = await fetchClient.get("/tasks", config()).catch((): null => {
        return null;
    });
    if (!res) return null;
    return res.data;
}

export const getTodayTasks = async () => {
    const res: any = await fetchClient.get("/tasks/today", config()).catch((): null => {
        return null;
    });
    if (!res) return null;
    return res.data;
}